import React, { useState } from 'react';
import { Camera, Loader2 } from 'lucide-react';
import toast from 'react-hot-toast';
import { downloadElementAsPng } from '../utils/captureElementAsPng';

interface Props {
  targetRef: React.RefObject<HTMLElement | null>;
  forumId: string;
  darkMode: boolean;
  className?: string;
}

const ForumCardScreenshotButton: React.FC<Props> = ({
  targetRef,
  forumId,
  darkMode,
  className = '',
}) => {
  const [loading, setLoading] = useState(false);

  const handleClick = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();

    const element = targetRef.current;
    if (!element || loading) return;

    setLoading(true);
    try {
      await downloadElementAsPng(element, `forum-${forumId}`);
      toast.success('Ekran görüntüsü indirildi');
    } catch {
      toast.error('Ekran görüntüsü alınamadı');
    } finally {
      setLoading(false);
    }
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={loading}
      title="Kartın ekran görüntüsünü indir"
      aria-label="Kartın ekran görüntüsünü indir"
      className={`flex items-center justify-center w-10 h-10 rounded-lg border transition-colors disabled:opacity-60 ${
        darkMode
          ? 'border-gray-600 text-gray-300 hover:bg-gray-700 hover:text-white'
          : 'border-gray-200 text-gray-600 hover:bg-gray-50 hover:text-gray-900'
      } ${className}`}
    >
      {loading ? <Loader2 size={18} className="animate-spin" /> : <Camera size={18} />}
    </button>
  );
};

export default ForumCardScreenshotButton;
